import { takeLatest } from 'redux-saga/effects';
import {
    GET_JOBPROFILE_REQUEST,
    UPDATE_JOBPROFILE_REQUEST
} from '../constants/jobProfileActionTypes'
import {
    getJobProfileSuccess,
    getJobProfileFailure,
    updateJobProfileSuccess,
    updateJobProfileFailure
} from "../actions/jobProfileActions";
import { handleApiRequest } from '../utils/sagaUtils';
import {apiCall} from "../utils/api";

const getJobProfile = (data) => {
    return apiCall(`${process.env.REACT_APP_API_URL}/employment-api/getJobProfile`, 'POST', data);
}
const updateJobProfile = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employment-api/updateJobProfile`, 'POST', data);

function* getJobProfileSaga(action) {
    yield* handleApiRequest(action, getJobProfile, getJobProfileSuccess, getJobProfileFailure);
}

function* updateJobProfileSaga(action) {
    yield* handleApiRequest(action, updateJobProfile, updateJobProfileSuccess, updateJobProfileFailure);
}

export default function* watchJobProfileSagas() {
    yield takeLatest(GET_JOBPROFILE_REQUEST, getJobProfileSaga);
    yield takeLatest(UPDATE_JOBPROFILE_REQUEST, updateJobProfileSaga);
}